import apiClient from '../apiClient';
import { GET_INVOICE_BY_TRANSACTION_ID_URL } from '../apiUrl';

const getInvoiceByTransactionIdApi = Id => {
  return apiClient.get(GET_INVOICE_BY_TRANSACTION_ID_URL(Id));
};

export default getInvoiceByTransactionIdApi;
